import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from './Pagination';
import EditImage from './EditImage';
import ReturnToWorkItem from './ReturnToWorkItem';
import Counts from './Counts';
import QuickReport from './QuickReport';
import Delete from './Delete';
import Sort from './Sort';

export default function ActionBar() {
  const { selectedImageIds = [] } = useSelector((state) => state.images);

  return (
    <div style={container}>
      <Counts />
      <div style={content}>
        <Pagination />
        <div style={buttons}>
          <EditImage disabled={selectedImageIds.length === 0} />
          <QuickReport />
          <Delete />
          <ReturnToWorkItem />
          <Sort />
        </div>
      </div>
    </div>
  );
}

const container = {
  gridColumn: '1 / -1',
  display: 'flex',
  background: '#424242',
};

const content = {
  display: 'flex',
  flexGrow: 1,
  padding: '0 1em',
};

const buttons = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5em',
};
